<template>
    <section id="print">
        <div class="rowVar">
            <ul>
                <template v-for="(variety, index) in varieties">
                    <li v-for="q in +variety.agencyQuantity" class="variety varietyRow">
                        <div class="varietyContainer">
                            <div class="barcodeContainer">
                                <input
                                    type="text"
                                    v-model="variety.product_title"
                                    class="varietyPrice"
                                />
                              
                                
                                <!-- <div class="itemRow">
                                    <b>{{ checkLabel(item.key) }}</b>
                                    <span class="varName">
                                        {{ variety.title }}
                                    </span>
                                </div> -->

                                  <barcode
                                        class="varietyBarcode"
                                        fontSize="8"
                                        width="1"
                                        marginBottom="0"
                                        :displayValue="false"
                                        height="20"
                                       :value="variety.variety_barcode"
                                    >
                                    </barcode>

                                <span class="varietyId">
                                    {{ variety.variety_barcode }}
                                </span>
                                <span class="priceName" :class="{'hiddenPrice':showPrice==false}">
                                    <span>
                                        {{ formatPrice(variety.unit_price) }}

                                    </span>
                                    <span class="toman"> تومان</span>
                                </span>
                                <div v-if="variety.attributes && variety.attributes.length" :class="{'themePiceVariety':showPrice==false}">
                                    <div v-for="item in variety.attributes" :key="item.id">
                                        <span class="varName" v-if="variety.color && variety.color.name">
                                            {{ item.pivot.value + ' | ' + variety.color.name}}
                                        </span>
                                        <span class="varName" v-else>
                                            {{ item.pivot.value}}
                                        </span>
                                    </div>
                                </div>
                                <div v-else :class="{'themePiceVariety':showPrice==false}">
                                    <span class="varName">
                                        {{ extractColor(variety.variety_title) }}
                                    </span>
                                </div>
                                <span class="shopName">فروشگاه پاشیک</span>
                                <!-- <span class="priceName" v-if="variety.unit_price > variety.price">
                                    <del>{{ formatPrice(variety.unit_price) }} تومان</del>
                                </span>
                                <span class="priceName">
                                    {{ formatPrice(variety.price) }} تومان  
                                </span> -->
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
        <button id="printBtn" @click="print">پرینت</button>
    </section>
</template>

<script>
import printVarietiesImpl from "@@/core/pages/Havale/HavaleBarcodeLmpl";
export default {
    extends: printVarietiesImpl,
};
</script>

<style src="@@/core/pages/printVarieties/printVarietiesStyle.css"></style>
